import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cell from "components/menu/dashboard/merchandiser/merchandiser-services-cell";

import {
    fetchMerchandiserDashboardConfirmedServices,
} from "api/menu/dashboard/actions";

class MerchandiserServices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentWeek: 0,
            currentFromDate: moment().startOf("week").format("YYYY-MM-DD"),
            currentToDate: moment().endOf("week").format("YYYY-MM-DD")
        };
        this.makeRequest = this.makeRequest.bind(this);

        this.makeRequest();
    }

    makeRequest = (ind = 0) => {
        const { currentFromDate, currentToDate } = this.state;
        const fromDate = moment(currentFromDate).add(ind, "week").format("YYYY-MM-DD");
        const toDate = moment(currentToDate).add(ind, "week").format("YYYY-MM-DD");

        this.props.fetchMerchandiserDashboardConfirmedServices(fromDate, toDate, (response) => {
            if (response) {
                this.setState({
                    currentFromDate: fromDate,
                    currentToDate: toDate
                });
            }
        });
    };

    render () {
        const { merchandiserServices } = this.props;
        const { currentFromDate, currentToDate } = this.state;

        const sortedData = [];
        const
            mondayArr = [],
            tuesdayArr = [],
            wednesdayArr = [],
            thursdayArr = [],
            fridayArr = [],
            saturdayArr = [],
            sundayArr = [];

        merchandiserServices.forEach(item => {
            if(item.serviceConfirmation.estimatedDate)
            {
                switch (moment(item.serviceConfirmation.estimatedDate).day()) {
                    case 1:
                        mondayArr.push(item);
                        break;
                    case 2:
                        tuesdayArr.push(item);
                        break;
                    case 3:
                        wednesdayArr.push(item);
                        break;
                    case 4:
                        thursdayArr.push(item);
                        break;
                    case 5:
                        fridayArr.push(item);
                        break;
                    case 6:
                        saturdayArr.push(item);
                        break;
                    case 7:
                        sundayArr.push(item);
                        break;
                    default:
                        break;
                }
            }
            else
            {
                switch (moment(item.earliestDate).day()) {
                    case 1:
                        mondayArr.push(item);
                        break;
                    case 2:
                        tuesdayArr.push(item);
                        break;
                    case 3:
                        wednesdayArr.push(item);
                        break;
                    case 4:
                        thursdayArr.push(item);
                        break;
                    case 5:
                        fridayArr.push(item);
                        break;
                    case 6:
                        saturdayArr.push(item);
                        break;
                    case 7:
                        sundayArr.push(item);
                        break;
                    default:
                        break;
                }
            }

        });

        const maxLen = Math.max(
            mondayArr.length,
            tuesdayArr.length,
            wednesdayArr.length,
            thursdayArr.length,
            fridayArr.length,
            saturdayArr.length,
            sundayArr.length
        );

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < maxLen; i++) {
            sortedData.push({
                monday: mondayArr[i] || null,
                tuesday: tuesdayArr[i],
                wednesday: wednesdayArr[i],
                thursday: thursdayArr[i],
                friday: fridayArr[i],
                saturday: saturdayArr[i],
                sunday: sundayArr[i]

            });
        }

        return (
            <div className="card mb-3">
                <div className="card-header p-1 pl-2 pr-2">
                    <div className="d-flex justify-content-between align-items-center">
                        <button
                            className="btn btn-primary"
                            onClick={() => this.makeRequest(-1)}
                        >
                            <FontAwesomeIcon className="mr-2" icon="angle-left" title="Previous" />
                            Previous week
                        </button>
                        <h4 className="mb-0">{currentFromDate} - {currentToDate}</h4>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.makeRequest(1)}
                        >
                            Next week
                            <FontAwesomeIcon className="ml-2" icon="angle-right" title="Next" />
                        </button>
                    </div>
                </div>
                <div className="card-body p-0">
                    <ReactTable
                        data={sortedData}
                        headerClassName="table-header"
                        columns={[
                            {
                                Header: "Monday",
                                headerClassName: "text-left",
                                accessor: "monday",
                                Cell: ({ original }) => (
                                    <Cell original={original.monday} />
                                )
                            },
                            {
                                Header: "Tuesday",
                                headerClassName: "text-left",
                                accessor: "tuesday",
                                Cell: ({ original }) => (
                                    <Cell original={original.tuesday} />
                                )
                            },
                            {
                                Header: "Wednesday",
                                headerClassName: "text-left",
                                accessor: "wednesday",
                                Cell: ({ original }) => (
                                    <Cell original={original.wednesday} />
                                )
                            },
                            {
                                Header: "Thursday",
                                headerClassName: "text-left",
                                accessor: "thursday",
                                Cell: ({ original }) => (
                                    <Cell original={original.thursday} />
                                )
                            },
                            {
                                Header: "Friday",
                                headerClassName: "text-left",
                                accessor: "friday",
                                Cell: ({ original }) => (
                                    <Cell original={original.friday} />
                                )
                            },
                            {
                                Header: "Saturday",
                                headerClassName: "text-left",
                                accessor: "saturday",
                                Cell: ({ original }) => (
                                    <Cell original={original.saturday} />
                                )
                            },
                            {
                                Header: "Sunday",
                                headerClassName: "text-left",
                                accessor: "sunday",
                                Cell: ({ original }) => (
                                    <Cell original={original.sunday} />
                                )
                            }
                        ]}
                        className="-striped -highlight schedules-table"
                        style={{
                            height: "calc(100vh - 380px)",
                        }}
                    />
                </div>
            </div>
        );
    }
}

MerchandiserServices.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    merchandiserServices: state.dashboard.merchandiserServices,
});

const mapStateToDispatch = dispatch => ({
    fetchMerchandiserDashboardConfirmedServices: bindActionCreators(
        fetchMerchandiserDashboardConfirmedServices,
        dispatch
    )
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(MerchandiserServices);
